import type { AppearanceIntent, ResolvedAppearance } from './constants';

/**
 * Pure resolution mapping — the single place intent + live OS preference
 * become a concrete "light" | "dark" value. Mirrored (hand-duplicated,
 * necessarily) by the pre-paint script in index.html; scriptParity.test.ts
 * guards the two staying in lockstep.
 */
export function resolveAppearance(
  intent: AppearanceIntent,
  prefersDark: boolean
): ResolvedAppearance {
  switch (intent) {
    case 'light':
      return 'light';
    case 'dark':
      return 'dark';
    case 'system':
      return prefersDark ? 'dark' : 'light';
    default: {
      const exhaustiveCheck: never = intent;
      return exhaustiveCheck;
    }
  }
}
